/**
 * Base class for all domain models.
 * @typeParam T - The plain interface type this model serializes to/from.
 *
 * Subclasses must implement:
 *   - `serialize(): T` (named serialize instead of toJSON so Next.js RSC can pass models across the server/client boundary)
 *   - `static fromJSON(json: T): SubclassModel` (enforced by convention; TypeScript cannot require static methods)
 */
export abstract class BaseModel<T> {
  abstract serialize(): T
}
